import { render } from "./probaworkflows_sidebar.html?vue&type=template&id=5d17a4f6&external"
import script from "./probaworkflows_sidebar.js?vue&type=script&lang=js&external"
export * from "./probaworkflows_sidebar.js?vue&type=script&lang=js&external"

import "./probaworkflows_sidebar.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__